import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'

import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'
import messages from '@/utils/messages'


export default /*@__PURE__*/_defineComponent({
  __name: 'BtnSendFocusedInstitutionalToApprove',
  props: {
    accordionRef: {}
  },
  setup(__props: any) {

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()
const router = useRouter()

/**
 * ✅ REGRA DE EXIBIÇÃO
 */
const showSendToApproveButton = computed(() => {
  const status = institutionalStore.institutionalDetail?.status

  return (
    authStore.currentUserCanCreateInstitutional &&
    !institutionalStore.institutionalDetail?.cadastroEditado && status !== 0 &&
    (
      !status ||
      status === CONST_INSTITUTIONAL_STATUS.DRAFT.id ||
      status === CONST_INSTITUTIONAL_STATUS.ON_EDITING.id
  
    )
  )
})

/**
 * ✅ ENVIAR PARA APROVAÇÃO
 */
/**
 * ✅ ENVIAR PARA APROVAÇÃO
 */
/*const onSendInstitutionalToApproveBtnClick = async () => {
  try {
    pagesUtilStore.showLoading = true

    const detail = institutionalStore.institutionalDetail
    const id = detail?.id

    // ✅ fallback: se imagensDraft vazio, usa imagens do detail (já salvas no backend)
    const imagensParaProcessar = institutionalStore.imagensDraft.length
      ? institutionalStore.imagensDraft
      : (detail?.imagens || []).map(img => ({
          posicaoImagem: img.posicaoImagem,
          urlS3: img.urlS3,
          duracaoImagem: img.duracaoImagem ?? 5,
          file: null
        }))

    const imagensFinais = await institutionalStore.uploadImagens(imagensParaProcessar)

    // ✅ fallback: se telasDraft vazio, usa telasCadastradas do detail
    const telas = institutionalStore.telasDraft.length
      ? institutionalStore.telasDraft
      : (detail?.telasCadastradas || [])

    // ✅ fallback: exibeTelaAbertura do detail
    const exibeTelaAbertura = institutionalStore.exibeTelaAberturaRascunho !== false
      ? institutionalStore.exibeTelaAberturaRascunho
      : detail?.exibeTelaAbertura ?? false

    await institutionalStore.sendToApproval(imagensFinais, telas, exibeTelaAbertura)

    messages.showSuccessMsg('Cadastro enviado para aprovação!')
    router.push({ name: EnumRouteNames.INSTITUTIONAL_VIEW, params: { id } })

  } catch (error: any) {
    console.error(error)
    messages.showErrorMsg(error?.message || 'Erro ao enviar para aprovação.')
  } finally {
    pagesUtilStore.showLoading = false
  }
}*/

const onSendInstitutionalToApproveBtnClick = async () => {
  try {
    pagesUtilStore.showLoading = true

    const detail = institutionalStore.institutionalDetail
    const id = detail?.id

    // ✅ PEGA AS TELAS DO ACCORDION
   // const telasSelecionadas = props.accordionRef?.getTelasSelecionadas()

    let telasSelecionadas = props.accordionRef?.getTelasSelecionadas()


// ✅ fallback GARANTIDO pro cadastro
if (!telasSelecionadas || telasSelecionadas.length === 0) {
  const imagens = institutionalStore.imagensDraft

  const temInicial = imagens.some(img =>
    [1, 2, 3, 4, 8, 9, 10, 11].includes(img.posicaoImagem)
  )

  const temAguarde = imagens.some(img =>
    [6, 7].includes(img.posicaoImagem)
  )

  telasSelecionadas = []

  telasSelecionadas.push({ tipoTela: 'ABERTURA' })

  if (temInicial) {
    telasSelecionadas.push({ tipoTela: 'INICIAL' })
  }

  if (temAguarde) {
    telasSelecionadas.push({ tipoTela: 'AGUARDE' })
  }
}

    const imagensParaProcessar = institutionalStore.imagensDraft.length
      ? institutionalStore.imagensDraft
      : (detail?.imagens || []).map((img: any) => ({
          posicaoImagem: img.posicaoImagem,
          urlS3: img.urlS3,
          duracaoImagem: img.duracaoImagem ?? 5,
          file: null
        }))

    let imagensFinais: any[] = []

    if (imagensParaProcessar && imagensParaProcessar.length > 0) {
      imagensFinais = await institutionalStore.uploadImagens(imagensParaProcessar)
    } else {
      imagensFinais = []
    }

    const telas = institutionalStore.telasDraft.length
      ? institutionalStore.telasDraft
      : (detail?.telasCadastradas || [])

    const exibeTelaAbertura = institutionalStore.exibeTelaAberturaRascunho !== false
      ? institutionalStore.exibeTelaAberturaRascunho
      : detail?.exibeTelaAbertura ?? false

    const response = await institutionalStore.sendToApproval(
      imagensFinais,
      telasSelecionadas,
      exibeTelaAbertura
    )

    institutionalStore.clearReviewData()

    messages.showSuccessMsg('Cadastro enviado para aprovação!')

    const finalId = response?.id || id
    if (finalId) {
      router.push({
        name: EnumRouteNames.INSTITUTIONAL_VIEW,
        params: { id: finalId }
      })
    } else {
      router.push({ name: EnumRouteNames.INSTITUTIONAL_SEARCH })
    }
  } catch (error: any) {
    console.error(error)
    messages.showErrorMsg(
      error?.response?.data?.message || 'Erro ao enviar para aprovação.'
    )
  } finally {
    pagesUtilStore.showLoading = false
  }
}


const props = __props


return (_ctx: any,_cache: any) => {
  const _component_c_q_btn = _resolveComponent("c-q-btn")!

  return (showSendToApproveButton.value)
    ? (_openBlock(), _createBlock(_component_c_q_btn, {
        key: 0,
        id: "btn-send-institutional-to-approve",
        propBtnLabel: "Enviar para Aprovação",
        propBtnFunction: onSendInstitutionalToApproveBtnClick,
        propBtnTransparent: false,
        propBtnSize: _unref(EnumButtonSizes).LARGE_1
      }, null, 8, ["propBtnSize"]))
    : _createCommentVNode("", true)
}
}

})